import { IMAGE_MIME_TYPES } from 'pages/Batch/configs';

import type { ICropFlip, ICropAttrsBatch } from 'types/store';

import type { IProcessResult } from './toolchain';

const { PI } = Math;

const cropImage = (image: HTMLImageElement, attrs: ICropAttrsBatch[], rotate: number, flip: ICropFlip, key: string): Promise<IProcessResult> => {
  const currentCropItem = attrs.find(item => item.key === key);
  if (!currentCropItem) {
    throw new Error('cropImage function - Error');
  }

  const { width } = image;

  const canvas = document.createElement('canvas');

  const { x: currentCropX, y: currentCropY, width: currentCropWidth, height: currentCropHeight } = currentCropItem;
  const ratio = width / currentCropItem.initWidth;

  const {
    x: cropX,
    y: cropY,
    width: cropWidth,
    height: cropHeight,
  } = {
    x: currentCropX * ratio,
    y: currentCropY * ratio,
    width: currentCropWidth * ratio,
    height: currentCropHeight * ratio,
  };

  const isPortrait = [0, 180].includes(rotate);

  canvas.width = isPortrait ? cropWidth || currentCropItem.initWidth : cropHeight || currentCropItem.initHeight;
  canvas.height = isPortrait ? cropHeight || currentCropItem.initHeight : cropWidth || currentCropItem.initWidth;

  const ctx = canvas.getContext('2d')!;
  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.rotate((rotate * PI) / 180);
  ctx.scale(flip.x || 1, flip.y || 1);

  ctx.drawImage(image, cropX, cropY, cropWidth, cropHeight, -cropWidth / 2, -cropHeight / 2, cropWidth, cropHeight);

  return new Promise(resolve => {
    canvas.toBlob(blob => blob && resolve({ blob, result: URL.createObjectURL(blob) }), IMAGE_MIME_TYPES.WEBP);
  });
};

export default cropImage;
